import {
  authSetDeviceSelectStateDismiss,
  authSetDeviceSelectStateOpenModal,
  authSetDeviceStatusChange,
  useAuthState,
  useOptionalUser,
} from "@/src/OS/Login/State";
import { DateTime } from "luxon";
import { useEffect, useMemo } from "react";
import { AppState } from "react-native";

export function useCurrentEmployeeSelectControllerState() {
  const [, dispatch] = useAuthState();
  const user = useOptionalUser();

  const employeeSelectState = user?.employeeSelectState;
  useEffect(() => {
    dispatch(
      authSetDeviceStatusChange(DateTime.now().toISO(), AppState.currentState)
    );
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      dispatch(authSetDeviceStatusChange(DateTime.now().toISO(), nextAppState));
    });
    return () => {
      subscription.remove();
    };
  }, [dispatch]);

  return useMemo(
    () => ({
      dismiss: () => dispatch(authSetDeviceSelectStateDismiss()),
      openModal: () => dispatch(authSetDeviceSelectStateOpenModal()),
      employeeSelectState: employeeSelectState ?? "none",
    }),
    [employeeSelectState, dispatch]
  );
}
